import axios from "axios";

import { BASE_URL } from "./constants";

const publicGet = async (url) => {
  try {
    const response = await axios.get(`${BASE_URL}${url}`);
    return response.data;
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.message || error.message,
      data: null,
    };
  }
};

export const fetchCmsBlogList = async ({ limit = 100, offset = 0 } = {}) =>
  publicGet(`cms/blog?limit=${limit}&offset=${offset}`);

export const fetchCmsBlogPost = async (slug) =>
  publicGet(`cms/blog/${encodeURIComponent(slug)}`);

export const fetchCmsSeoAll = async () => publicGet("cms/seo?all=1");

export const fetchCmsSeoForPath = async (path) =>
  publicGet(`cms/seo?path=${encodeURIComponent(path)}`);

export const fetchCmsSitemap = async () => publicGet("cms/sitemap");

export const fetchCmsPage = async (slug) =>
  publicGet(`cms/pages/${encodeURIComponent(slug)}`);

export const fetchCmsLegislativeMap = async () => publicGet("cms/legislative-map");
